export const DEFAULT_EXTENSIONS = '.jpg, .jpeg, .tif, .tiff, .png, .pdf';

export const MORE_EXTENSIONS =
  '.txt, .doc, .docx, .odt, .xls, .xlsx, .pdf, .gif, .bmp, .jpg, .jpeg, .png, .tif, .tiff, .zip, .7z, .rar, .arj';
